<template>
  <div>
    <Main
      :height="height"
      :loading="loading"
      :tablePage="page"
      :tableData="tableData"
      :type="type"
      ref="tableMain"
    >
      <PageHeader
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
      />
      <pagination
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </Main>
  </div>
</template>
<script>
import Main from './main.vue'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
export default {
  mixins: [BaseTable],
  components: {
    PageHeader,
    Main,
  },
  props: {
    height: { type: Number, default: 500 },
    type: { type: String, default: 'radio' },
  },
  data() {
    return {
      usePage: true,

      loading: false,
      tableData: [],
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .sysUserWorkShopApi({
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
    },
    choiceData() {
      return this.$refs.tableMain.choiceData()
    },
  },
}
</script>
